import React, { useEffect } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { sha256 } from 'js-sha256';
import { observer } from 'mobx-react';
import _ from 'lodash';
import { useStores } from 'hooks';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Login from './components/Login';
import loginMutation from './graphql/login.graphql';
import forgotPasswordMutation from './graphql/forgotPassword.graphql';
import { useQueryParams, StringParam } from 'use-query-params';

export default observer(() => {
  const { authStore } = useStores();
  const history = useHistory();
  const [optionQueries] = useQueryParams({ redirect: StringParam });

  useEffect(() => {
    if (authStore.isLoggedIn) {
      const { redirect } = optionQueries;
      const redirectUri = redirect ? decodeURIComponent(redirect) : '/';
      history.push(redirectUri);
    } else {
      authStore.logoutAll();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authStore.isLoggedIn]);

  const onError = (err) => {
    toast.error(_.get(err, 'graphQLErrors[0].message'), err);
  };

  const onCompleted = () => toast.success('Password reset mail sent.');

  const [login] = useMutation(loginMutation, {
    fetchPolicy: 'no-cache',
    onError,
    onCompleted,
  });

  const [forgotPassword] = useMutation(forgotPasswordMutation, { fetchPolicy: 'no-cache', onError, onCompleted });

  const onForgotPasswordSubmit = (data) => {
    forgotPassword({
      variables: { input: { email: data.email } },
    });
  };

  const onLoginSubmit = (data) => {
    const formattedForm = {
      email: data.email,
      password: sha256(data.password),
    };
    login({
      variables: { input: formattedForm },
    })
      .then((r) => {
        if (_.get(r, 'data.login.token')) {
          authStore.changeNewIdentity(r.data.login.token);
        }
        if (_.get(r, 'data.login.viewer')) {
          authStore.setViewer(r.data.login.viewer);
        }
      })
      .catch(onError);
  };

  return (
    <Login onLoginSubmit={onLoginSubmit} onForgotPasswordSubmit={onForgotPasswordSubmit} />
  );
});
